import { ShieldFillCheck, ListUl } from "react-bootstrap-icons";

const RULES = [
  {
    id: 1,
    title: "Staff",
    body: (
      <>
        <p>Staff are volunteers who are here to help the community. Please be patient when asking for help and you will be assisted as soon as a staff member can help you.</p>
        <p>Do not impersonate staff, whether it is in-game or in chat.</p>
      </>
    ),
  },
  {
    id: 2,
    title: "Your account is your responsibility",
    body: (
      <>
        <p>If someone breaks the rules using your account, it is your account that will be punished.</p>
        <p>Scamming players is against the rules, however your account and gear are your responsibility. We do not recommend sharing your account at all — support will not be given for scam cases regarding shared accounts.</p>
      </>
    ),
  },
  {
    id: 3,
    title: "Accounts / Trading of any form",
    body: (
      <p>Selling or trading accounts, items, or CPs outside the game for real-life currency or any other exchange will result in a permanent ban without prior notice or warning.</p>
    ),
  },
  {
    id: 4,
    title: "Bots / Exploits — 3 Strike Rule",
    body: (
      <>
        <div className="strike-list">
          <div className="strike-item strike-1">1st strike — 7 day ban</div>
          <div className="strike-item strike-2">2nd strike — 14 day ban</div>
          <div className="strike-item strike-3">3rd strike — Permanent Botjail / Ban</div>
        </div>
        <p>If you are caught autohunting or using a bot, macro, or program to hunt, the hunting account will be permanently banned and a strike added to your main account. The only authorized method of hunting is manual.</p>
        <p>It is against the rules to exploit any bug, glitch, or oversight to gain an advantage. This includes duplication glitches and will be punished based on severity.</p>
        <p>Sharing or discussing bots or exploits is considered an offence and will not be tolerated.</p>
      </>
    ),
  },
  {
    id: 5,
    title: "Social rules — Bullying and harassment",
    body: (
      <>
        <p>Racial or ethnic slurs, personal insults, inappropriate sexual or religious comments, offensive political discussions, discrimination, promoting self-harm, and excessive foul language will not be tolerated.</p>
        <p>Harassing via multiple characters or dodging account mutes is not accepted and will result in a harsher punishment.</p>
        <p>Sharing or publishing personal details of another player without their consent (doxing) is forbidden and will be taken extremely seriously.</p>
        <p>Malicious attempts to obtain private information (e.g. IP grabbing) are not accepted.</p>
      </>
    ),
  },
  {
    id: 6,
    title: "Advertising",
    body: (
      <>
        <p>Any attempt to advertise another server is prohibited, whether through names or web links.</p>
        <p>Do not send any IP addresses or server domain names that could be used to connect to another server. This includes advertising through private messages.</p>
      </>
    ),
  },
  {
    id: 7,
    title: "Donation chargebacks",
    body: (
      <p>Attempting donation chargebacks is forbidden as per the Donation T&amp;C's and will result in a permanent HWID ban.</p>
    ),
  },
  {
    id: 8,
    title: "General rule",
    body: (
      <p>By playing the server, you agree to the above rules. Staff reserve the right to apply rules at their discretion, and any player found to be harming the experience for others may be punished or banned.</p>
    ),
  },
];

function Rules() {
  return (
    <div className="rules-page">

      {/* Hero */}
      <div className="rules-hero">
        <div className="rules-hero-icon"><ShieldFillCheck /></div>
        <h2>Server Rules</h2>
        <p>You must follow all of the rules on this page to play Paragon Conquer.</p>
      </div>

      {/* Table of contents — derived from RULES, always in sync */}
      <div className="rules-toc">
        <div className="rules-toc-header">
          <ListUl size={14} /> Contents
        </div>
        <ol className="rules-toc-list">
          {RULES.map(r => (
            <li key={r.id}>
              <a href={`#rule-${r.id}`}>{r.title}</a>
            </li>
          ))}
        </ol>
      </div>

      {/* Rule cards — same source */}
      {RULES.map(r => (
        <div key={r.id} className="rule-card" id={`rule-${r.id}`}>
          <div className="rule-card-header">
            <span className="rule-number">{r.id}</span>
            <h5>{r.title}</h5>
          </div>
          <div className="rule-body">{r.body}</div>
        </div>
      ))}

      {/* Disclaimer */}
      <div className="rules-disclaimer">
        <p>Paragon Conquer reserves the right to punish you for any abuse of the game, systems, or any acts that we deem have malicious intent behind them.</p>
      </div>

    </div>
  );
}

export { Rules };
